import { render, staticRenderFns } from "./CategoryEditView.vue?vue&type=template&id=297f74f7&scoped=true&"
import script from "./CategoryEditView.vue?vue&type=script&lang=js&"
export * from "./CategoryEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297f74f7",
  null
  
)

export default component.exports